import React from "react";

const AppVersion = ({ version }: { version: string }) => (
  <div className="w-full text-2xs text-center text-secondary/50 font-manrope pb-sm">
    <span>v{version}</span>
  </div>
);

export default AppVersion;
